import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./ApplyCourse.scss";
import axios from "axios";
import { readCourseAvailability, bookingAvailabilityMessage } from "../bookingCapacityState";
import { ToastContainer, toast } from "react-toastify";

const ApplyCourse = () => {
  const [data, setData] = useState({});
  const [bookingPending, setBookingPending] = useState(false);
  const [loadError, setLoadError] = useState("");
  const bookingInFlight = useRef(false);
  const { option2 } = useParams();

  const courseDetails = async () => {
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");

    await axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=getCourseDetailsByCourseIdapply&school_id=${localStorage.getItem(
          "session_school_id"
        )}&level_id=${localStorage.getItem(
          "session_user_level_id"
        )}&course_id=${option2}&from_app_new=1&student_id=${localStorage.getItem(
          "session_user_id"
        )}&status=1`
      )
      .then((resp) => {
        setData(resp.data.data || {});
        setLoadError(resp.data.data ? "" : "Die Kursdaten sind derzeit nicht verfügbar.");
      }).catch(() => { setData({}); setLoadError("Die Kursdaten konnten nicht geladen werden. Bitte aktualisieren."); });
  };

  // const addWishList = async (courseTitle) => {
  //   const login_cookie = localStorage.getItem("session_user_login_cookie");
  //   const login_user_id = localStorage.getItem("session_user_id");
  //   const login_action_type = localStorage.getItem("session_user_type");

  //   await axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=enrollprovisional&school_id=${localStorage.getItem(
  //         "session_school_id"
  //       )}&level_id=${localStorage.getItem(
  //         "session_user_level_id"
  //       )}&course_id=${option2}&user_id=${localStorage.getItem(
  //         "session_user_id"
  //       )}&course_title=${courseTitle}&status=1`
  //     )
  //     .then((resp) => {
  //       if (resp.data.status === true) {
  //         toast("We're sorry. Course is full.");
  //       }
  //       if (resp.data.status === false) {
  //         toast(resp.data.message);
  //       }
  //     });
  // };

  const enrollList = async (courseTitle) => {
    if (bookingInFlight.current) return;
    bookingInFlight.current = true;
    setBookingPending(true);
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");

    await axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=enrollcourse&school_id=${localStorage.getItem(
          "session_school_id"
        )}&level_id=${localStorage.getItem(
          "session_user_level_id"
        )}&course_id=${option2}&user_id=${localStorage.getItem(
          "session_user_id"
        )}&course_title=${courseTitle}&status=1`
      )
      .then((resp) => {
        if (resp.data.status === true) {
          toast("ENROLLED SUCCESSFULLY");
        }

        if (resp.data.status === false) {
          toast(resp.data.message);
        }
      }).catch(() => { toast("Die Buchung konnte nicht sicher bestätigt werden. Der aktuelle Stand wird nachgelesen; bitte nicht blind wiederholen."); })
      .finally(async () => { await courseDetails(); bookingInFlight.current = false; setBookingPending(false); });
  };

  useEffect(() => {
    courseDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="apply_course_section">
      <ToastContainer />
      <div className="container-fluid">
        <div className="user_detail">
          <div className="apply_course_title">
            <h2>Apply Course</h2>
          </div>
        </div>
        {loadError && <p role="alert">{loadError}</p>}
        <button type="button" className="btn btn_primary" disabled={bookingPending} onClick={courseDetails}>Aktualisieren</button>
        {Object.values(data)?.filter((item) => item && typeof item === "object" && !Array.isArray(item)).map((item, index) => {
          const availability = readCourseAvailability(item);
          const english = availability.language === "en";
          return (
          <div key={index}>
            <div className="apply_course_inner">
              <div className="apply_course_card row">
                <div className="my_courses_card col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="apply_course_card_inner">
                    <div className="apply_course_card_title">
                      <h2>{item?.course_title}</h2>
                    </div>
                    <div className="apply_course_detail">
                      <ul className="apply_course_list">
                        <li className="apply_course_item">
                          <span>Phase :</span>
                          <span>
                            {item?.course_level_number} ({item?.level_name})
                          </span>
                        </li>
                        <li className="apply_course_item">
                          <span>Starting Time :</span>
                          <span>{item.class_start_time}</span>
                        </li>
                        <li className="apply_course_item">
                          <span>Ending Time :</span>
                          <span>{item.class_end_time}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="my_courses_card col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="apply_course_card_inner">
                    <div className="apply_course_detail">
                      <h3>{english ? "Course availability" : "Kursbelegung"}</h3>
                      {availability.known && <>
                        <p>{english ? "Date: " : "Termin: "}{availability.courseDate}</p>
                        <p>{english ? "Reserved room places: " : "Belegte Raumplätze: "}{availability.occupied} / {availability.capacity}</p>
                        <p>{english ? "Available room places: " : "Freie Raumplätze: "}{availability.roomRemaining}</p>
                        <p>{english ? "Role balance: women " : "Paarverteilung: Frauen "}{availability.femaleCount}{english ? ", men " : ", Männer "}{availability.maleCount}</p>
                        <p>{english ? "The total room capacity also applies to any available role places." : "Auch bei freier Paarrolle gilt zusätzlich die gesamte Raumkapazität."}</p>
                      </>}
                      <p role="status">{bookingAvailabilityMessage(availability)}</p>
                    </div>
                  </div>
                </div>
              </div>
              {!availability.alreadyBooked && <div className="apply_course_btn">
                <div className="enroll_btn">
                  <button type="button" className="btn btn_primary" disabled={!availability.allowSingle || bookingPending} onClick={() => enrollList(item?.course_title)}>
                    {bookingPending ? (english ? "Checking…" : "Wird geprüft…") : (english ? "Book once" : "Einmalig buchen")}
                  </button>
                </div>
                <div className="enroll_btn">
                  {availability.allowPair && !bookingPending ? <Link className="btn btn_primary" to={`/Home/course/enrollCouple/course_id=${item.course_id}&course_title=${item.course_title}`}>
                    {english ? "Check pair booking" : "Paarbuchung prüfen"}
                  </Link> : <button type="button" className="btn btn_primary" disabled>{english ? "Check pair booking" : "Paarbuchung prüfen"}</button>}
                  <p>{bookingAvailabilityMessage(availability, true)}</p>
                </div>
              </div>}
            </div>

            <div className="apply_data_table">
              {Object.values(item.course_goal_first_four || {})?.map(
                (firstFourData, firstFourIndex) => (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col" colSpan="3">
                            {
                              Object.keys(item.course_goal_first_four || {})[
                                firstFourIndex
                              ]
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-group-divider">
                        {firstFourData?.map(
                          (innerTableData, innerTableIndex) => (
                            <tr
                              dangerouslySetInnerHTML={{
                                __html: innerTableData.title,
                              }}
                              key={innerTableIndex}
                            ></tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )
              )}

              {Object.values(item.course_goal_rest_after_four || {})?.map(
                (firstFourData, firstFourIndex) => (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col" colSpan="3">
                            {
                              Object.keys(item.course_goal_first_four)[
                                firstFourIndex
                              ]
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-group-divider">
                        {Object.values(firstFourData)?.map(
                          (innerTableData, innerTableIndex) => (
                            <tr
                              dangerouslySetInnerHTML={{
                                __html: innerTableData.title,
                              }}
                              key={innerTableIndex}
                            ></tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )
              )}
            </div>
          </div>
        ); })}
      </div>
    </div>
  );
};

export default ApplyCourse;
